import { useFpB2bCartCalculate } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-calculate'
import { useFpB2bPaymentService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-payment-service'
import { CountryLocaleMap } from '@constants'
import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { useApiGetFpPayment } from '@hooks-api/fortune/useApiGetFpPayment'
import { PaymentMethodType, PaymentServiceType } from '@hooks-api/types/dataModel/payment'
import { CheckoutPayApplePayModule } from '@payments'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { ApplePay } from '@pets-ui/icons'
import { Radio } from '@pets-ui/Radio/Radio'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom-v5'
import { useContextPayment } from '../../../../fp-b2b-shared/components/PaymentProvider/PaymentProvider'
import { useCheckout } from '../../../../fp-b2b-shared/hooks/use-checkout'
import { paymentComponentStyle } from './PaymentMethodComponent'
export const PaymentCheckoutPayApplePay = () => {
  const { selectedPayment, setSelectedPayment, paymentMethods, setPaymentExecution, getActivePaymentModuleB2B, setConfiguredPaymentModule, isSdkInitialized, setIsLoadingPayment, isProcessingCheckout } = useContextPayment()
  const { trigger: getPaymentToken } = useApiGetFpPayment()
  const { env, countryCode, campaignId, campaignCode, platform } = useCheckout()
  const { calculateResult: campaignCouponCalculateResult } = useFpB2bCartCalculate(campaignId, campaignCode, platform)

  const currentMethod = paymentMethods.find(method => method.service_type === PaymentServiceType.CHECKOUTPAY && method.type === PaymentMethodType.APPLE_PAY)
  const checked = selectedPayment?.service_type === PaymentServiceType.CHECKOUTPAY && selectedPayment.type === PaymentMethodType.APPLE_PAY
  const paymentModule = getActivePaymentModuleB2B(PaymentServiceType.CHECKOUTPAY, PaymentMethodType.APPLE_PAY)
  const { total } = campaignCouponCalculateResult || {}
  const { transactionId: paymentTransactionIdFromUrl } = useParams<{ transactionId?: string }>()
  const { orderId, orderType } = useFpB2bPaymentService({ campaignId, paymentTransactionIdFromUrl, campaignCode, platform })

  const handleSelectPayment = useCallbackEvent(async () => {
    try {
      if (!campaignCode || (!paymentTransactionIdFromUrl && !total)) {
        throw new Error('Missing campaign code, total, selectedPayment')
      }
      if (!currentMethod) {
        throw new Error('Missing payment method')
      }
      setSelectedPayment(currentMethod)

      if (!(paymentModule instanceof CheckoutPayApplePayModule)) {
        throw new Error('Wrong module')
      }

      setIsLoadingPayment(true)
      const token = await getPaymentToken({
        order_type: orderType,
        order_id: orderId,
        payment_method_id: currentMethod.id,
      })

      const { app_id, app_key } = token.data.data.payment_service_provider_info
      if (!app_id || !app_key) {
        throw new Error('Missing app_id, app_key')
      }
      // Flow SDK：appKey / appEnv 在這裡先設好，實際 mount 在使用者按下單後的 dialog 才呼叫 applyCkoSession
      paymentModule.configurePayment({ appKey: app_key, appEnv: env, locale: CountryLocaleMap[countryCode] })
      const { payment_transaction_id } = token.data.data
      setPaymentExecution({
        payment_transaction_id,
        service_pay_info: null,
        user_payment_token_info: undefined,
        payment_success_url: '',
        payment_fallback_url: '',
      })
      setConfiguredPaymentModule(paymentModule)
    }
    catch (e) {
      console.error(`[Apple Pay Checkout Pay] ${e}`)
    }
    finally {
      setIsLoadingPayment(false)
    }
  })

  const handleInitPayment = useCallback(async () => {
    // NOTE: isSdkInitialized promises that the payment module is init after sdk init
    const shouldInit = selectedPayment?.service_type === PaymentServiceType.CHECKOUTPAY && selectedPayment.type === PaymentMethodType.APPLE_PAY && (paymentTransactionIdFromUrl || total) && isSdkInitialized
    if (!shouldInit) return
    handleSelectPayment()
  }, [handleSelectPayment, isSdkInitialized, paymentTransactionIdFromUrl, selectedPayment?.service_type, selectedPayment?.type, total])

  // NOTE: init for default payment
  useEffect(() => {
    handleInitPayment()
  }, [handleInitPayment])
  return (
    <Box component="label" rootStyle={[paymentComponentStyle.root, paymentComponentStyle.radioPaymentChecked]}>
      <VStack flexGrow={1} gap={2.5}>
        <HStack alignItems="center" gap={2}>
          <Radio
            name="paymentCheckoutPayApplePay"
            checked={checked}
            value="paymentCheckoutPayApplePay"
            onChange={handleSelectPayment}
            disabled={isProcessingCheckout}
          />
          <ApplePay />
          <Text fontWeight={600} lineHeight="100%">
            Apple Pay
          </Text>
          <Box flexGrow={1} />
          {/* endIcon */}
        </HStack>
      </VStack>
    </Box>
  )
}
